/**
 * TASK RECURRENT UNIT — unità dell'intervallo di ricorrenza di un task.
 *
 * Allineato 1:1 all'enum Java
 * `modules/crm-util/src/main/java/it/dvel/crm/util/constants/TaskRecurrentUnit.java`
 * (NONE=0, DAY=1, WORKING_DAY=2, WEEK=3, MONTH=4, YEAR=5). Il backend REST
 * serializza int32 (`getValue()`); la conversione string↔int vive in
 * `taskMappers.ts` (tabella TASK_RECURRENT_UNIT_TO_INT).
 *
 * SYNC CROSS-LAYER — aggiunte/rinominazioni vanno replicate in parallelo su:
 *   - TaskRecurrentUnit.java (enum)
 *   - taskMappers.ts (TASK_RECURRENT_UNIT_TO_INT)
 *   - locales/{it,en}.json (chiavi task.recurrent.units.*)
 */
export type TaskRecurrentUnit = 'none' | 'day' | 'working-day' | 'week' | 'month' | 'year';

/**
 * Opzioni selezionabili come unità di ricorrenza. `none` è escluso: è il
 * valore sentinella per "task non ricorrente" (recurrent=false) e non va
 * mostrato quando l'utente sta scegliendo la cadenza.
 */
export const TASK_RECURRENT_UNITS: { value: TaskRecurrentUnit; label: string }[] = [
  { value: 'day', label: 'task.recurrent.units.day' },
  { value: 'working-day', label: 'task.recurrent.units.working-day' },
  { value: 'week', label: 'task.recurrent.units.week' },
  { value: 'month', label: 'task.recurrent.units.month' },
  { value: 'year', label: 'task.recurrent.units.year' },
];
